module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetLow@2x.addb137.webp";